import { TopTitleBar as CssModulesTopTitleBar } from '@sunwebgroup/uds-ui/top-title-bar'
import { styled } from 'styled-components'

const Root = styled(CssModulesTopTitleBar.Root)``

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/top-title-bar' instead.
 */
export const TopTitleBarWrapper = {
  Root,
  LeftArea: CssModulesTopTitleBar.LeftArea,
  CenterArea: CssModulesTopTitleBar.CenterArea,
  RightArea: CssModulesTopTitleBar.RightArea,
}
